export const GET_DISABILITAZIONE_CHIAMATE_AND_LOADING =
  "GET_DISABILITAZIONE_CHIAMATE_AND_LOADING";
export const EXPORT_DISABILITAZIONE_CHIAMATE_LOADING =
  "EXPORT_DISABILITAZIONE_CHIAMATE_LOADING";
export const CREATE_UPDATE_DELETE_BARRING = "CREATE_UPDATE_DELETE_BARRING";
export const GET_BARRING_BY_ID = "GET_BARRING_BY_ID";
export const GET_CREATE_BARRING_DATA = "GET_CREATE_BARRING_DATA";
